import { IOMACredential } from '@/interfaces/iomaCredential';
import { queryIOMACredencial } from '@/services/iomaCredentials.service';
import { Effect, Reducer } from '@umijs/max';
import { redirectNotFound } from '@/utils/errorRedirect';

export interface ModelType {
  namespace: string;
  state: { credential: null | IOMACredential };
  effects: {
    sendHistory: Effect;
    fetchIomaCredentailDetail: Effect;
  };
  reducers: {
    setCredential: Reducer<any>;
    setHistory: Reducer<any>;
  };
}

const Model: ModelType = {
  namespace: 'iomaCredentailDetail',

  state: {
    credential: null,
  },

  effects: {
    *fetchIomaCredentailDetail({ payload }, { call, put, all }) {
      try {
        const [credential] = yield all([call(queryIOMACredencial, payload)]);
  
        yield put({
          type: 'setCredential',
          payload: { credential: credential.data },
        });
      } 
      catch (error) {
        redirectNotFound(error);
      }
    },

    *sendHistory({ payload }) {
      yield {
        type: 'setHistory',
        payload,
      };
    },
  },

  reducers: {
    setCredential(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },

    setHistory(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};

export default Model;
